import { useCallback, useEffect, useState } from "react";

import { getTeacherDashboard } from "../services/teacherApi";

export default function useTeacherAccess() {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setDashboard(await getTeacherDashboard());
    } catch (requestError) {
      setDashboard(null);
      setError(requestError.response?.data?.detail || "Impossible de charger l’espace enseignant.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const refreshDashboard = useCallback(async () => {
    const data = await getTeacherDashboard();
    setDashboard(data);
    return data;
  }, []);

  const updateWalletBalance = useCallback((balance) => {
    if (!Number.isFinite(balance)) return;
    setDashboard((current) => current ? {
      ...current,
      wallet: {
        ...(current.wallet || {}),
        balance,
        currency: current.wallet?.currency || "FCFA",
      },
    } : current);
  }, []);

  const updateNotificationUnread = useCallback((count) => {
    if (!Number.isFinite(count)) return;
    setDashboard((current) => current ? {
      ...current,
      unread: {
        ...(current.unread || {}),
        notifications: Math.max(0, count),
      },
    } : current);
  }, []);

  return { dashboard, loading, error, reload, refreshDashboard, updateWalletBalance, updateNotificationUnread };
}
